/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateProductCollectionRequest,
    EditProductCollectionRequest,
    IdResponse,
    LinkProductToCollectionRequest,
} from '../models';

export interface ProductCollectionApiControllerArchiveProductCollectionRequest {
    storeId: string;
    id: string;
}

export interface ProductCollectionApiControllerCreateProductCollectionRequest {
    storeId: string;
    createProductCollectionRequest: CreateProductCollectionRequest;
}

export interface ProductCollectionApiControllerDeleteProductCollectionRequest {
    storeId: string;
    id: string;
}

export interface ProductCollectionApiControllerEditProductCollectionRequest {
    storeId: string;
    id: string;
    editProductCollectionRequest: EditProductCollectionRequest;
}

export interface ProductCollectionApiControllerLinkProductsRequest {
    storeId: string;
    id: string;
    linkProductToCollectionRequest: LinkProductToCollectionRequest;
}

export interface ProductCollectionApiControllerUnarchiveProductCollectionRequest {
    storeId: string;
    id: string;
}

/**
 * 
 */
export class ProductCollectionsApi extends runtime.BaseAPI {

    /**
     */
    async productCollectionApiControllerArchiveProductCollectionRaw(requestParameters: ProductCollectionApiControllerArchiveProductCollectionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling productCollectionApiControllerArchiveProductCollection.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCollectionApiControllerArchiveProductCollection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections/{id}:archive`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCollectionApiControllerArchiveProductCollection(requestParameters: ProductCollectionApiControllerArchiveProductCollectionRequest): Promise<void> {
        await this.productCollectionApiControllerArchiveProductCollectionRaw(requestParameters);
    }

    /**
     */
    async productCollectionApiControllerCreateProductCollectionRaw(requestParameters: ProductCollectionApiControllerCreateProductCollectionRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling productCollectionApiControllerCreateProductCollection.');
        }

        if (requestParameters.createProductCollectionRequest === null || requestParameters.createProductCollectionRequest === undefined) {
            throw new runtime.RequiredError('createProductCollectionRequest','Required parameter requestParameters.createProductCollectionRequest was null or undefined when calling productCollectionApiControllerCreateProductCollection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createProductCollectionRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async productCollectionApiControllerCreateProductCollection(requestParameters: ProductCollectionApiControllerCreateProductCollectionRequest): Promise<IdResponse> {
        const response = await this.productCollectionApiControllerCreateProductCollectionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async productCollectionApiControllerDeleteProductCollectionRaw(requestParameters: ProductCollectionApiControllerDeleteProductCollectionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling productCollectionApiControllerDeleteProductCollection.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCollectionApiControllerDeleteProductCollection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCollectionApiControllerDeleteProductCollection(requestParameters: ProductCollectionApiControllerDeleteProductCollectionRequest): Promise<void> {
        await this.productCollectionApiControllerDeleteProductCollectionRaw(requestParameters);
    }

    /**
     */
    async productCollectionApiControllerEditProductCollectionRaw(requestParameters: ProductCollectionApiControllerEditProductCollectionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling productCollectionApiControllerEditProductCollection.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCollectionApiControllerEditProductCollection.');
        }

        if (requestParameters.editProductCollectionRequest === null || requestParameters.editProductCollectionRequest === undefined) {
            throw new runtime.RequiredError('editProductCollectionRequest','Required parameter requestParameters.editProductCollectionRequest was null or undefined when calling productCollectionApiControllerEditProductCollection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editProductCollectionRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCollectionApiControllerEditProductCollection(requestParameters: ProductCollectionApiControllerEditProductCollectionRequest): Promise<void> {
        await this.productCollectionApiControllerEditProductCollectionRaw(requestParameters);
    }

    /**
     */
    async productCollectionApiControllerLinkProductsRaw(requestParameters: ProductCollectionApiControllerLinkProductsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling productCollectionApiControllerLinkProducts.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCollectionApiControllerLinkProducts.');
        }

        if (requestParameters.linkProductToCollectionRequest === null || requestParameters.linkProductToCollectionRequest === undefined) {
            throw new runtime.RequiredError('linkProductToCollectionRequest','Required parameter requestParameters.linkProductToCollectionRequest was null or undefined when calling productCollectionApiControllerLinkProducts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections/{id}:linkProducts`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.linkProductToCollectionRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCollectionApiControllerLinkProducts(requestParameters: ProductCollectionApiControllerLinkProductsRequest): Promise<void> {
        await this.productCollectionApiControllerLinkProductsRaw(requestParameters);
    }

    /**
     */
    async productCollectionApiControllerUnarchiveProductCollectionRaw(requestParameters: ProductCollectionApiControllerUnarchiveProductCollectionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling productCollectionApiControllerUnarchiveProductCollection.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCollectionApiControllerUnarchiveProductCollection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/product-collections/{id}:unarchive`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCollectionApiControllerUnarchiveProductCollection(requestParameters: ProductCollectionApiControllerUnarchiveProductCollectionRequest): Promise<void> {
        await this.productCollectionApiControllerUnarchiveProductCollectionRaw(requestParameters);
    }

}
